// Escritório 5914 = "AAWZ Fee Fixo Migração", shell tenant de cadastro público
// (aawz_fee_fixo/core/cadastro_aberto.py, ESCRITORIO_DA_LANDING_FEE_FIXO,
// backend), onde o cadastro público cria o usuário como Assessor (não
// gestor). Regra de negócio (CTO/CEO, ago/2026): DENTRO desse escritório,
// quem é GESTOR usa a plataforma normalmente; quem não é gestor só pode usar
// o módulo Fee Fixo — navbar, Home e roteamento direto por URL, os três.
//
// Global (não dentro de um módulo) porque `router/index.js` (guard de rota) e
// `navegacao-v2/components/gestao-sidebar.vue` (navbar) precisam da MESMA
// regra — duplicar criaria dois lugares pra manter em dia.
export const ESCRITORIO_FEE_FIXO_MIGRACAO_ID = 5914

export const ehEscritorioFeeFixoMigracao = (user) => {
  const escritorio = (user && user.escritorio) || {}
  return Number(escritorio.id_interno) === ESCRITORIO_FEE_FIXO_MIGRACAO_ID
}

// Só quem, DENTRO do escritório 5914, não é gestor — gestor usa a plataforma
// normalmente (regra do usuário, 12/08/2026).
export const deveVerSoFeeFixo = (user) => {
  return ehEscritorioFeeFixoMigracao(user) && !(user && user.IS_GESTOR)
}
